import { hasPlanContent } from '../../../features/exploratory-tests';
import type { ExploratoryTestData } from './types';

export function shouldDefaultExploratorySidebarToReport(
  test: ExploratoryTestData,
  isInFlight: boolean
): boolean {
  // A fuzz run shows its growing attack surface in the Plan tab while running,
  // then opens on the report once it has finished.
  if (test.flavor === 'fuzz') return !isInFlight && test.reportJson !== null;

  const hasReportContent =
    !!test.summary ||
    (test.reportJson?.testPlan?.length ?? 0) > 0 ||
    (test.reportJson?.appended?.length ?? 0) > 0;
  const hasLiveChecklist = isInFlight && (test.liveTestPlan?.length ?? 0) > 0;
  const isLegacyNonPlanningRun = test.status !== 'planning' && !hasPlanContent(test);

  return isLegacyNonPlanningRun || (!isInFlight && hasReportContent) || hasLiveChecklist;
}
